document.addEventListener('DOMContentLoaded', function () {
  var revealItems = document.querySelectorAll('.tt-reveal');

  if (revealItems.length) {
    var hasReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (hasReducedMotion) {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
    } else if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              obs.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.16,
          rootMargin: '0px 0px -8% 0px'
        }
      );

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    } else {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
    }
  }

  var heroImages = document.querySelectorAll('.tt-hero__media img');

  if (heroImages.length) {
    var handleHeroParallax = function () {
      var scrollY = window.scrollY || window.pageYOffset;

      heroImages.forEach(function (image) {
        var move = Math.min(scrollY * 0.08, 28);

        image.style.transform =
          'scale(1.04) translate3d(0,' + move + 'px,0)';
      });
    };

    window.addEventListener('scroll', handleHeroParallax, { passive: true });
    handleHeroParallax();
  }
});